<template>
    <v-dialog :value="modal_test_cancel.active" max-width="600">
        <v-card class="pa-4">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('test_cancel')" aria-hidden="true" translate="no">close</v-icon>
            <v-card-title :class="{'title': $vuetify.breakpoint.xs, 'display-1': $vuetify.breakpoint.smAndUp}">{{ $t("Прервать тест?") }}</v-card-title>
            <v-card-text class="title mt-4">{{ course_name }}</v-card-text>
            <v-card-actions class="mt-4">
                <v-layout wrap>
                    <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}" @click.native="test_cancel()">{{$t('Прервать')}}</buttonRed>
                    <buttonBdWhite :class="{'flex xs12 mt-2': $vuetify.breakpoint.xs}" @click.native="CLOSE_MODAL('test_cancel')">{{ $t("Отмена") }}</buttonBdWhite>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    buttonBdWhite,
  },
  props: {
    modal_type: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('course_info/modals', [
      'modal_test_cancel',
    ]),
    ...mapGetters('course_info', [
      'course_name',
    ]),
  },
  methods: {
    ...mapMutations('course_info/modals', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('testing', [
      'test_cancel',
    ]),
  },
};
</script>
